// extracted by mini-css-extract-plugin
var _1 = "SunscriptionServicesFormGroup_noServicesMessage__1YeVU";
var _2 = "SunscriptionServicesFormGroup_servicesGroup__0UWwR";
export { _1 as "noServicesMessage", _2 as "servicesGroup" }
